<script>
import gql from "graphql-tag";
import { tournamentMatchFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";
import GenerateKODrawDialog from "./generateKODrawDialog.vue";

export default {
  name: "GenerateRRDrawDialog",
  extends: GenerateKODrawDialog,
  data: function() {
    return {
      poolSize: {
        label: "The maximum number of competitors per pool",
        type: DialogInputTypes.number,
        value: 3
      },
      competitorsPerPoolPerFlight: {
        label: "Number competitors from each pool to advance to knock rounds",
        type: DialogInputTypes.number,
        value: 1
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [
          this.poolSize,
          this.competitorsPerPoolPerFlight,
          this.nConsolationFlights,
          this.nSeeds
        ];
      }
    },
    title: {
      get() {
        return "Generate Round Robin Draw";
      }
    },
    instructions: {
      get() {
        return "Generate a round-robin draw with pool play and knockout rounds";
      }
    }
  },
  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation(
              $tournamentId: ID!
              $knockoutOptions: KnockoutFormatOptions!
              $roundRobinOptions: RoundRobinFormatOptions!
            ) {
              generateRoundRobinDraw(
                tournamentId: $tournamentId
                knockoutOptions: $knockoutOptions
                roundRobinOptions: $roundRobinOptions
              ) {
                ...TournamentMatch
              }
            }
            ${tournamentMatchFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            knockoutOptions: {
              numberOfConselationFlights: this.nConsolationFlights.value,
              seeds: this.nSeeds.value
            },
            roundRobinOptions: {
              poolSize: this.poolSize.value,
              competitorsPerPoolPerFlight: this.competitorsPerPoolPerFlight
                .value
            }
          }
        })
        .then(result => {
          this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit("setNotification", `Generated Round Robin draw`);
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to generate Round Robin draw");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// generateRRDrawDialog.vue?b242f668